import type { JSX } from "react";
import type { Attribute } from "../sign-up-request";
import { Typography } from "@mui/material";
import { AttributeTextField } from "../components";
import { SignUpStep } from "../step";
import { useAutofocus } from "../util";


export class CollectEmailAddressStep extends SignUpStep {
	override title: string = "Your Email Address";
	override view: () => JSX.Element = () => <CollectEmailAddressStepView step={ this }/>;

	get attribute(): Attribute<string> {
		return this.app.state.attribute("email");
	}

	protected override async handleSubmit(): Promise<void> {
		if(this.app.isEmailAddressVerified(this.attribute.value)) {
			this.app.onEmailVerified();
			return;
		}

		const response = await this.app.api.sendVerificationEmail({ to: this.attribute.value });
		if(!response.ok) {
			console.error("Bad response:", response); // eslint-disable-line no-console
			alert(response.error.message); // eslint-disable-line no-alert
			return;
		}

		this.app.onVerificationHashReceived(response.data.hash);
	}
}

const EMAIL_FIELD_DESCRIPTION_ID = "purser__emailDescription";
const CollectEmailAddressStepView = (p: { step: CollectEmailAddressStep }): JSX.Element => {
	const autofocus = useAutofocus<HTMLInputElement>();

	return (
		<>
			<div id={ EMAIL_FIELD_DESCRIPTION_ID }>
				<Typography component="p">
					Please enter your personal business email address.
				</Typography>
				<Typography component="p" variant="body2">
					We will use this email address to send you a verification code and as
					your log in to Charter Index, and it will be our primary means of
					communicating with you.
				</Typography>
			</div>

			<AttributeTextField
				attribute={ p.step.attribute }
				name="emailAddress"
				label="Email Address"
				type="email"
				required
				aria-describedby={ EMAIL_FIELD_DESCRIPTION_ID }
				inputRef={ autofocus }
				sx={{ marginY: "auto" }}
			/>
		</>
	);
};
